<ng-container *ngIf="(vm$ | async) as vm">
  <ng-container *ngIf="vm.isVoice">
    <app-message-logs-table-voice></app-message-logs-table-voice>
  </ng-container>
  <ng-container *ngIf="vm.isSms || vm.isWhatsapp">
    <app-message-logs-table-sms-whatsapp></app-message-logs-table-sms-whatsapp>
  </ng-container>
</ng-container>
